var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy } from '@angular/core';
import { EngineState } from 'src/app/engine/state/engine.state';
import { Observable, Subject } from 'rxjs';
import { Select } from '@ngxs/store';
import { takeUntil, filter } from 'rxjs/operators';
import { AnimationService } from 'src/app/engine/animation.service';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { ViewService } from '../../view.service';
var ViewMediaBarComponent = /** @class */ (function () {
    function ViewMediaBarComponent(animationService, viewService) {
        this.animationService = animationService;
        this.viewService = viewService;
        this.showScrubber = true;
        this.ngUnsubscribe = new Subject();
    }
    ViewMediaBarComponent.prototype.ngOnInit = function () {
        this.initChapterListener();
    };
    ViewMediaBarComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    ViewMediaBarComponent.prototype.initChapterListener = function () {
        var _this = this;
        this.selectedChapterId$.pipe(filter(function (chapterId) { return chapterId != null; }), takeUntil(this.ngUnsubscribe)).subscribe(function (chapterId) {
            _this.timerange = _this.animationService.getChapterLocalTimerange(chapterId);
        });
    };
    ViewMediaBarComponent.prototype.handlePlayClick = function () {
        this.viewService.toggleAnimation();
    };
    __decorate([
        Select(EngineState.getAnimationPlaying),
        __metadata("design:type", Observable)
    ], ViewMediaBarComponent.prototype, "animationPlaying$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapterId),
        __metadata("design:type", Observable)
    ], ViewMediaBarComponent.prototype, "selectedChapterId$", void 0);
    return ViewMediaBarComponent;
}());
export { ViewMediaBarComponent };
